export default {
  baseUrl: process.env.REACT_APP_BASE_URL
};



// WEBPACK FOOTER //
// ./src/config.js